module.exports = __webpack_public_path__ + "img/recorte-esquerda@2x.a578bb9f.png";